<template>
        <div class="alert oa-alert" >
            <div class="time">{{ alert.cc_timeslot | moment("HH:mm") }}</div>        
            <div class="info">
                <span>{{ alert.first_name }}</span>
                <span>#{{ alert.order_number }}</span>
            </div>
            <div class="price">
                <div class="detail">£{{ alert.total | total}}</div>
                <div class="oval" :data-complete="isComplete" @click="statusChange()"></div>    
            </div>
        </div>
</template>

<script>

export default {
	name: "Alert",
	props: ['alert'],
	components: {
		
	},
    data () {
        return {
            compleating: false
        }
    },
    methods : {
        statusChange () {
            if (this.alert.status === 'pending') {
                this.compleating = true
                this.$store.dispatch('alerts/completeAlert', { alert: this.alert })
                return
            }
            this.compleating = false
            this.$store.dispatch('alerts/unCompleteAlert', { alert: this.alert })
        }
    },
    computed: {
        isComplete () {
            return this.compleating
        }
    },
    mounted () {
        this.compleating = this.alert.status === 'complete'
    }
}

</script>

<style lang="scss" scoped>
    @import '@/scss/imports.scss';
	div.alert {
        
        height: 52px; width: 100%;
        margin: 8px 0px;
        background-color: #eeeeee;
        position: relative;
        font-size: 16px;
        color: #4a4a4a;
        
        .time, .price {
            width: 60px; height: 52px;
            background-color: #e17240;
            text-align: center;
            line-height: 52px;
            position: absolute;

        }
        .time { 
            color: white; 
            font-weight: 900;
        }
        .price {
            right: 0px; top: 0px;
            background-color: #eeeeee;
            width: 110px;
            .detail {
                float: left;
            }
        }
        .info {
            padding: 7px 0;
            padding-left: 80px;
            height: 100%; width: 100%;
            span { 
                text-transform: capitalize;
                display: block; 
            }
        }
        .oval {
            width: 36px;
            height: 36px;
            border: solid 3px #979797;
            border-radius: 20px;
            position: absolute;
            top: 8px; right: 8px;
            &[data-complete="true"] {
                background-image: url('../../assets/icons/acknowledged.svg');
                background-size: cover;
                border: none;
            }

        }

        [data-inline] {
            
            vertical-align: top;
            display: inline-block;
           
        }

	}
    
</style>



// WEBPACK FOOTER //
// src/components/alerts/OAAlert.vue